export const CARTITEM           = "SET_CART_ITEMS";
export const UPDATECARTDETAILS  = "UPDATECARTDETAILS" ;
export const CARTPAGEVISIBILITY = "CARTPAGEVISIBILITY";